const initialDashboardListState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  statusCounts: { CREATED: 0, STANDARD: 0, ALL: 0 },
  nbResult: 0,
  pageSize: 12,
  paginationPage: 1,
  selected: [],
  filter: {
    labels: "",
    status: [],
    legalForms: []
  },
  filterStatus: "",
  saving: false,
  saved: false
};
export const dashboardListReducer = (
  state = initialDashboardListState,
  action
) => {
  switch (action.type) {
    case "INIT_DASHBOARDS_LIST_FILTER": {
      return initialDashboardListState;
    }
    case "SET_DASHBOARDS_LIST": {
      return { ...state, items: action.dashboard };
    }
    case "FETCH_DASHBOARDS_LIST_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_DASHBOARDS_LIST_FULFILLED": {
      const { data, nbResult, statusCounts } = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data || [],
        selected: [],
        statusCounts: statusCounts,
        nbResult: nbResult
      };
    }
    case "SET_DASHBOARDS_SELECTED_ITEM": {
      return {
        ...state,
        selected: action.selected
      };
    }
    case "FETCH_DASHBOARDS_LIST_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        error
      };
    }
    case "SET_DASHBOARDS_LIST_PAGINATION_PAGE": {
      return { ...state, paginationPage: action.pageNumber };
    }
    case "SET_DASHBOARDS_LIST_PAGE_SIZE": {
      return {
        ...state,
        pageSize: action.pageSize,
        paginationPage: 1
      };
    }
    case "SET_DASHBOARDS_LIST_FILTER_TITLE": {
      return {
        ...state,
        filter: { ...state.filter, labels: action.title },
        paginationPage: 1
      };
    }
    case "SET_DASHBOARDS_LIST_FILTER_STATUS": {
      return {
        ...state,
        filter: { ...state.filter, status: action.status },
        paginationPage: 1
      };
    }
    case "SET_DASHBOARDS_LIST_FILTER_JURIDICAL_FORM": {
      return {
        ...state,
        filter: { ...state.filter, legalForms: action.legalForms },
        paginationPage: 1
      };
    }
    case "SET_DASHBOARD_LIST_FILTER": {
      return {
        ...state,
        filterStatus: action.filterStatus,
        paginationPage: 1
      };
    }
    case "SET_DASHBOARD_LIST_FILTER_IS_PUBLIC": {
      return {
        ...state,
        filter: {
          ...state.filter,
          isPublic: action.isPublic,
          operator: action.operator
        },
        paginationPage: 1
      };
    }
    case "SET_DASHBOARD_LIST_FILTER_NEW_DASHBOARD_IDS": {
      return {
        ...state,
        filter: {
          ...state.filter,
          newDashboardIds: action.newDashboardIds
        },
        paginationPage: 1
      };
    }
    case "DELETE_DASHBOARD_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "DELETE_DASHBOARD_FULFILLED": {
      let { params } = action.payload.config;
      let dashboards = [...state.items].filter(dashboard => {
        return params.id !== dashboard.id;
      });
      return { ...state, saved: true, saving: false, items: dashboards };
    }
    case "DELETE_DASHBOARD_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "DUPLICATE_DASHBOARD_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "DUPLICATE_DASHBOARD_FULFILLED": {
      return { ...state, saved: true, saving: false };
    }
    case "DUPLICATE_DASHBOARD_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "CHANGE_PRIVACY_DASHBOARD_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "CHANGE_PRIVACY_DASHBOARD_FULFILLED": {
      return { ...state, saved: true, saving: false };
    }
    case "CHANGE_PRIVACY_DASHBOARD_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "CHANGE_STATE_DASHBOARD_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "CHANGE_STATE_DASHBOARD_FULFILLED": {
      return { ...state, saved: true, saving: false };
    }
    case "CHANGE_STATE_DASHBOARD_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "USE_SHARED_DASHBOARD_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "USE_SHARED_DASHBOARD_FULFILLED": {
      return { ...state, saved: true, saving: false };
    }
    case "USE_SHARED_DASHBOARD_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "SET_DASHBOARD_PRIVATE_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "SET_DASHBOARD_PRIVATE_FULFILLED": {
      return { ...state, saved: true, saving: false };
    }
    case "SET_DASHBOARD_PRIVATE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dashboardList.js